import Result from './Result';

export default class extends Result {
  constructor(type, avatar, name, tag, id, prefix) {
    super(type, avatar, name);
    this.tag = `${prefix} @${tag}`;
    this.to = { name: 'Messenger', params: { chatId: id } };
  }
}
